

import '@lwc/synthetic-shadow';   // <-- FIRST LINE


import { createElement } from 'lwc';
import App from 'x/app';


// ✅ Amplify imports
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

console.log('MAIN.JS LOADED');


// ✅ Configure Amplify once at startup
Amplify.configure(awsconfig);


const elm = createElement('x-app', { is: App });
console.log('APP APPENDED');

document.body.appendChild(elm);


